import React from 'react';
import GenAIOpsHelp from '../genaiops/help/GenAIOpsHelp';
import AgentOpsHelp from '../agentops/help/AgentOpsHelp';
import APIKeysHelp from '../../settings/help/APIKeysHelp';
import LLMProvidersHelp from '../../settings/help/LLMProvidersHelp';
import SDKHelp from '../../settings/help/SDKHelp';
import JudgeRubricsHelp from '../../settings/help/JudgeRubricsHelp';

interface AIOperationsHelpProps {
  activeTab: string;
  activeSubTab?: string;
}

const AIOperationsHelp: React.FC<AIOperationsHelpProps> = ({ activeTab, activeSubTab }) => {
  // GenAIOps tabs
  switch (activeTab) {
    case 'overview':
      return <GenAIOpsHelp activeTab="overview" />;
    case 'observability':
      return <GenAIOpsHelp activeTab="observability" activeSubTab={activeSubTab} />;
    case 'registry':
      return <GenAIOpsHelp activeTab="registry" activeSubTab={activeSubTab} />;
    case 'evaluation':
      return <GenAIOpsHelp activeTab="evaluation" activeSubTab={activeSubTab} />;
    case 'governance':
      return <GenAIOpsHelp activeTab="governance" activeSubTab={activeSubTab} />;
    // AgentOps tabs
    case 'runs':
      return <AgentOpsHelp activeTab="runs" />;
    case 'tools':
      return <AgentOpsHelp activeTab="tools" />;
    case 'apm':
      return <AgentOpsHelp activeTab="apm" />;
    case 'incidents':
      return <AgentOpsHelp activeTab="incidents" />;
    // Settings tabs moved here
    case 'api-keys':
      return <APIKeysHelp />;
    case 'llm-providers':
      return <LLMProvidersHelp />;
    case 'judge-rubrics':
      return <JudgeRubricsHelp />;
    case 'sdk':
      return <SDKHelp />;
    default:
      return <GenAIOpsHelp activeTab="overview" />;
  }
};

export default AIOperationsHelp;
